import { api } from '@/api'
import { ErrorCode } from '@/errors/errorCode'
import { UiPlacementPlacement, UiPlacementType } from '@/types/api/ui-placement'

export async function fetchNavbarSuppliers({
  revalidate,
  errorCode,
  fresh = false,
}: {
  revalidate: number
  errorCode: ErrorCode
  fresh: boolean
}) {
  const [err, uiPlacement] = await api.be.uiPlacement.getMany(
    {
      placement: [
        UiPlacementPlacement.SUPPLIER_TOP_NAV_LIST,
        UiPlacementPlacement.VENUE_TOP_NAV_LIST,
      ],
      type: [UiPlacementType.SUPPLIER],
      fresh,
    },
    {
      next: {
        revalidate,
      },
    }
  )

  if (err) {
    console.log(`Error: ${errorCode}`, err)
    return { suppliers: [], venues: [] }
  }

  let navbarSuppliers = uiPlacement?.data[UiPlacementType.SUPPLIER]?.[
    UiPlacementPlacement.SUPPLIER_TOP_NAV_LIST
  ]
    ?.sort((a, b) => a.sort_order - b.sort_order)
    .map((item) => item.supplier!)

  let navbarVenues = uiPlacement?.data[UiPlacementType.SUPPLIER]?.[
    UiPlacementPlacement.VENUE_TOP_NAV_LIST
  ]
    ?.sort((a, b) => a.sort_order - b.sort_order)
    .map((item) => item.supplier!)

  return { suppliers: navbarSuppliers || [], venues: navbarVenues || [] }
}
